module.exports = __webpack_public_path__ + "static/img/cont48 (3).012aa9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont48 (3).jpg
// module id = KOT7
// module chunks = 0